import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de los calendarios de plazos de pago (HU-05): plazos (día y
// mes) por tipo de gestión (1, 2, IN, V), uno predeterminado por tipo y los
// grupos de carreras que usan cada uno (como una regla de cobro y sus grupos).
// Contrato: UNICEN/modules/economico/docs/calendarios-plazos.openapi.yaml
//
//   GET  /economico/calendarios-plazos?tipo_gestion&estado          -> { calendarios }
//   POST /economico/calendarios-plazos { nombre, tipo_gestion, plazos: [{ dia, mes }] }
//   PUT  /economico/calendarios-plazos/:id { nombre, plazos }
//   POST /economico/calendarios-plazos/:id/predeterminado | /desactivacion | /reactivacion
//   GET  /economico/calendarios-plazos/grupos-candidatos?tipo_gestion -> { planes: [{ grupos }] }
//   PUT  /economico/calendarios-plazos/:id/grupos { grupos: [id_grupo] }
//   POST /economico/calendarios-plazos/:id/grupos/:id_grupo    (si usaba otro del tipo, se lo mueve)
//   DELETE /economico/calendarios-plazos/:id/grupos/:id_grupo  (vuelve al predeterminado)

const resource = '/economico/calendarios-plazos';

const useCalendariosPlazosApi = {
  listar({ tipo, estado } = {}) {
    return apiClient.get(resource, conToken({ params: { tipo_gestion: tipo || undefined, estado: estado || undefined } }));
  },

  crear({ nombre, tipo_gestion, plazos }) {
    return apiClient.post(resource, { nombre, tipo_gestion, plazos }, conToken());
  },

  editar(idCalendario, { nombre, plazos }) {
    return apiClient.put(`${resource}/${idCalendario}`, { nombre, plazos }, conToken());
  },

  marcarPredeterminado(idCalendario) {
    return apiClient.post(`${resource}/${idCalendario}/predeterminado`, {}, conToken());
  },

  desactivar(idCalendario) {
    return apiClient.post(`${resource}/${idCalendario}/desactivacion`, {}, conToken());
  },

  reactivar(idCalendario) {
    return apiClient.post(`${resource}/${idCalendario}/reactivacion`, {}, conToken());
  },

  /** Los grupos de los planes activos con el calendario propio que tienen en un tipo de gestión. */
  gruposCandidatos(tipoGestion) {
    return apiClient.get(`${resource}/grupos-candidatos`, conToken({ params: { tipo_gestion: tipoGestion } }));
  },

  /** Dejar el calendario con exactamente esos grupos. */
  cambiarGrupos(idCalendario, grupos) {
    return apiClient.put(`${resource}/${idCalendario}/grupos`, { grupos }, conToken());
  },

  asignarGrupo(idCalendario, idGrupo) {
    return apiClient.post(`${resource}/${idCalendario}/grupos/${idGrupo}`, {}, conToken());
  },

  quitarGrupo(idCalendario, idGrupo) {
    return apiClient.delete(`${resource}/${idCalendario}/grupos/${idGrupo}`, conToken());
  },
};

export default useCalendariosPlazosApi;
